<div class="container mtp30 mbt30 xsmtp20 smmtp30 xsmbt20 booking-section">
  <h2 class="titlest2 mbt10 center pdlr15 fw-bold" translate>
    lblVehicleServiceBooking
  </h2>
  <p translate class="mbt30 center font24 pdlr15"> lblWelcomeMessage</p>
</div>
<app-booking-steps></app-booking-steps>
